<script setup lang="ts"></script>

<template>
  <span class="inline-block shrink-0 h-[12px] w-[12px] rounded-full" />
</template>
